import React from 'react';
import { RoleComponentRender } from '../../../../Core/Core';
import { Roles } from '../../../../types/Types';
import { Button } from 'antd';
import classes from './style/EducationCard.module.css';
import { useNavigate } from 'react-router-dom';
import { ITest } from '../../../../types/TestType';
interface ButtonGrupComProps {
  test: ITest;
  id: number;
}
const ButtonGrupCom = (props: ButtonGrupComProps) => {
  const { test, id } = props;
  const navigate = useNavigate();

  return (
    <div className={classes.ContetnGrup}>
      {test ? (
        test.result?.is_passed === true ? (
          <>
            <div>
              Результаты теста: {test.result?.points}/{test.result?.questions_count}
            </div>{' '}
            Тест пройден
          </>
        ) : (
          <>
            <div>Результаты теста: -/-</div>
            <Button onClick={() => navigate(`test-questions/${id}`)}>Пройти тест</Button>
          </>
        )
      ) : (
        <>
          <div className={classes.resultContent}>Результаты теста: -/-</div>
          <Button disabled={true}>Пройти тест</Button>
        </>
      )}
    </div>
  );
};

export default ButtonGrupCom;
